// suscripcion-mp.js — Suscripción con débito automático vía Mercado Pago
// Flores de la Plazoleta · El Solar Creative Group
//
// Hace dos cosas:
// 1. En TODAS las páginas: captura UTMs / fbclid / gclid de la URL y los guarda
//    en localStorage (last-touch, 90 días) para atribuir la suscripción a pauta.
// 2. En las páginas de producto de suscripción (donde el snippet suscripcion-mp.liquid
//    renderiza #fdlp-submp): maneja el botón, el formulario de datos de envío,
//    la redirección al checkout de Mercado Pago y la confirmación al volver.
//
// Dos modos del widget:
//   · fijo (alstroemerias): data-plan-url, un plan de MP por producto.
//   · por variante (bouquets, data-plan-mode="variant"): el plan de MP depende de
//     Frecuencia × Duración. La variante elegida se traduce a una llave
//     "quincenal|6" que se busca en los planes (snippet suscripcion-mp-planes).
// El back_url de los planes de bouquets es la colección /collections/suscripciones
// (los planes se comparten entre bouquets), así que la confirmación al volver de MP
// corre también en páginas sin widget.
//
// El cobro ocurre en Mercado Pago (fuera del checkout de Shopify). Las órdenes
// las crea el webhook api/mp-webhook.ts en el proyecto Vercel flores-plazoleta.

(function () {
  'use strict';

  var ATTRIB_KEY = 'fdlp_attrib';
  var ENVIO_KEY = 'fdlp_mp_envio';
  var ATTRIB_TTL_DAYS = 90;

  /* ---------- 1. Captura de atribución (corre en todas las páginas) ---------- */

  function captureAttribution() {
    var params = new URLSearchParams(window.location.search);
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid'];
    var found = {};
    var any = false;
    keys.forEach(function (k) {
      var v = params.get(k);
      if (v) {
        found[k] = v;
        any = true;
      }
    });
    if (!any) return;
    try {
      // Last-touch: la visita más reciente con parámetros de campaña pisa la anterior,
      // igual que la atribución last-click del dashboard.
      localStorage.setItem(ATTRIB_KEY, JSON.stringify({ params: found, at: Date.now() }));
    } catch (e) {
      /* localStorage bloqueado (Safari privado, etc.) — la atribución queda orgánica */
    }
  }

  function getAttribution() {
    try {
      var raw = localStorage.getItem(ATTRIB_KEY);
      if (!raw) return {};
      var data = JSON.parse(raw);
      var ageDays = (Date.now() - (data.at || 0)) / 86400000;
      if (ageDays > ATTRIB_TTL_DAYS) return {};
      return data.params || {};
    } catch (e) {
      return {};
    }
  }

  /* ---------- 2. Widget de suscripción (solo si el snippet está presente) ---------- */

  function initWidget(root) {
    var planUrl = root.getAttribute('data-plan-url');
    var apiConfirm = root.getAttribute('data-api-confirm');
    var variantMode = root.getAttribute('data-plan-mode') === 'variant';
    var mainBox = root.querySelector('[data-submp-main]');
    var hint = root.querySelector('[data-submp-hint]');
    var variants = {};
    var plans = {};
    if (variantMode) {
      try { variants = JSON.parse(root.getAttribute('data-variants') || '{}'); } catch (e) { /* sin variantes */ }
      try { plans = JSON.parse(document.getElementById('fdlp-submp-planes').textContent || '{}'); } catch (e) { /* sin planes */ }
    }

    function currentVariantId() {
      var input = document.querySelector('product-form-component input[name="id"]');
      var id = input && input.value;
      if (!id) id = new URLSearchParams(window.location.search).get('variant');
      return id;
    }

    // Traduce la variante elegida al plan de MP y a la frase de cobro.
    function refreshVariant() {
      var v = variants[currentVariantId()];
      var parts = v ? v.k.split('|') : [];
      // Un plan de MP por Frecuencia|Duración (llave "quincenal|6"): el plan lleva el descuento y el plazo.
      var url = v && plans[v.k];
      planUrl = url || '';
      if (mainBox) mainBox.hidden = !url;
      if (!hint) return;
      if (!url) { hint.textContent = ''; return; }
      var meses = parseInt(parts[1], 10);
      var entregas = parts[0] === 'quincenal' ? '2 entregas al mes' : '1 entrega al mes';
      var cobro = (v.m || Math.round(v.t / meses)).toLocaleString('es-CO');
      hint.textContent = 'Paga COP ' + cobro + ' cada mes (' + entregas + ') con débito automático. ' +
        'Sin pagar todo el período por adelantado — cancelas cuando quieras desde Mercado Pago.';
    }

    if (variantMode) {
      refreshVariant();
      document.addEventListener('variant:update', function () { setTimeout(refreshVariant, 0); });
      document.addEventListener('change', function () { setTimeout(refreshVariant, 50); });
    }
    var openBtn = root.querySelector('[data-submp-open]');
    var modal = root.querySelector('[data-submp-modal]');
    var form = root.querySelector('[data-submp-form]');
    var closeEls = root.querySelectorAll('[data-submp-close]');
    var errorBox = root.querySelector('[data-submp-error]');

    if (openBtn && modal) {
      openBtn.addEventListener('click', function () {
        modal.removeAttribute('hidden');
        document.documentElement.style.overflow = 'hidden';
      });
      closeEls.forEach(function (el) {
        el.addEventListener('click', function () {
          modal.setAttribute('hidden', '');
          document.documentElement.style.overflow = '';
        });
      });
    }

    if (form) {
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var data = {};
        new FormData(form).forEach(function (v, k) {
          data[k] = String(v).trim();
        });
        if (!planUrl) return;
        data.producto = window.location.pathname;
        try {
          localStorage.setItem(ENVIO_KEY, JSON.stringify(data));
        } catch (e) { /* sin storage igual seguimos: el webhook opera con el email del pago */ }
        // Redirigir al checkout de suscripciones de Mercado Pago.
        // El back_url del plan apunta de vuelta a esta página de producto.
        window.location.href = planUrl;
      });
    }

    handleReturn(root, apiConfirm);

    if (errorBox) errorBox.textContent = '';
  }

  /* ---------- 3. Retorno desde Mercado Pago (con o sin widget en la página) ---------- */

  function handleReturn(root, apiConfirm) {
    var query = new URLSearchParams(window.location.search);
    var preapprovalId = query.get('preapproval_id');
    var returned = preapprovalId || query.get('mp_confirm') === '1';
    if (!returned) return;
    if (!root) {
      root = document.getElementById('fdlp-submp-return') || buildReturnBanner();
      apiConfirm = root.getAttribute('data-api-confirm');
    }
    if (!apiConfirm) return;

    var envio = {};
    try {
      envio = JSON.parse(localStorage.getItem(ENVIO_KEY) || '{}');
    } catch (e) { /* sin datos de envío: el backend igual registra la suscripción */ }

    showBanner(root, 'loading');

    fetch(apiConfirm, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        preapproval_id: preapprovalId || null,
        email: envio.email || null,
        shipping: {
          first_name: envio.nombre || '',
          last_name: envio.apellido || '',
          phone: envio.telefono || '',
          address1: envio.direccion || '',
          address2: envio.complemento || '',
          city: envio.ciudad || '',
          province: envio.departamento || 'Cundinamarca',
        },
        utms: getAttribution(),
        page: envio.producto || window.location.pathname,
      }),
    })
      .then(function (res) { return res.json(); })
      .then(function (json) {
        if (json && json.ok) {
          try { localStorage.removeItem(ENVIO_KEY); } catch (e) { /* no-op */ }
          showBanner(root, 'ok');
        } else {
          showBanner(root, 'warn');
        }
      })
      .catch(function () {
        showBanner(root, 'warn');
      });
  }

  // Los bouquets vuelven a la colección, que no tiene el widget: se arma un aviso mínimo.
  function buildReturnBanner() {
    var box = document.createElement('div');
    box.id = 'fdlp-submp-return';
    box.setAttribute('data-api-confirm', 'https://fdlp-suscripciones.vercel.app/api/mp-confirm');
    box.style.cssText = 'max-width:760px;margin:16px auto;padding:0 16px';
    var base = 'padding:14px 16px;border-radius:6px;font-size:0.95rem;line-height:1.45;';
    var defs = [
      ['loading', 'Confirmando tu suscripción…', base + 'background:#f5f5f5;color:#555'],
      ['ok', '🌸 ¡Tu suscripción quedó activa! Recibirás tus flores según la frecuencia elegida. El cobro se hará automáticamente por Mercado Pago y puedes cancelar cuando quieras.', base + 'background:#eef7ea;color:#2e5c1f;border:1px solid #519a3a'],
      ['warn', 'Tu pago en Mercado Pago quedó registrado, pero no pudimos confirmar tus datos de envío. Escríbenos por WhatsApp o a hola@floresplazoleta.com para coordinar tu primera entrega.', base + 'background:#fdf3e3;color:#7a5210;border:1px solid #e0b34e'],
    ];
    defs.forEach(function (d) {
      var el = document.createElement('div');
      el.setAttribute('data-submp-banner-' + d[0], '');
      el.hidden = true;
      el.textContent = d[1];
      el.style.cssText = d[2];
      box.appendChild(el);
    });
    var host = document.querySelector('main') || document.body;
    host.insertBefore(box, host.firstChild);
    return box;
  }

  function showBanner(root, state) {
    var banners = {
      loading: root.querySelector('[data-submp-banner-loading]'),
      ok: root.querySelector('[data-submp-banner-ok]'),
      warn: root.querySelector('[data-submp-banner-warn]'),
    };
    Object.keys(banners).forEach(function (k) {
      if (!banners[k]) return;
      if (k === state) banners[k].removeAttribute('hidden');
      else banners[k].setAttribute('hidden', '');
    });
    var main = root.querySelector('[data-submp-main]');
    if (main && state !== 'loading') {
      // Tras confirmar, ocultamos el CTA para no invitar a una doble suscripción.
      if (state === 'ok') main.setAttribute('hidden', '');
    }
  }

  function init() {
    captureAttribution();
    var root = document.getElementById('fdlp-submp');
    if (root) initWidget(root);
    else handleReturn(null, null);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
